/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-misused-promises */

import React from 'react';
import classnames from 'classnames';
import { omit } from 'lodash-es';
import { Table, TableAddon, TableColumn } from 'tea-component';
import ReportTable from '../../../components/ReportTable';
import useDPSReportModule from '../../../_hooks/useDPSReportModule';
import { getUpdatesOfWeekChanges } from '../../services';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { CARD_TITLE, buildRecord, buildDefaultChanges, getColumnsEditable, setNewFileUrlChangesContent } from './utils';
import { DataType } from '@gp/enums/common';
import type { IBaseProps } from '@home/types/common';
import type { IDPSReportFilter, IDPSReportCalendarProjectSimpleVO } from '@gp/types/dpsReport/common';
import type { IDPSReportUpdatesOfTheWeekVO, IDPSReportUpdatesOfTheWeekChangeVO } from '@gp/types/dpsReport/v3';

import './index.scss';

interface IUpdatesOfWeekProps extends IBaseProps {
  // 标题
  title?: string;
  onTitleChange?: (payload: string) => void;
  // 是否loading
  isLoading?: boolean;
  filter: IDPSReportFilter;
  // projects集合数据
  projects?: IDPSReportCalendarProjectSimpleVO[] | null;
  // 模块数据
  value: IDPSReportUpdatesOfTheWeekVO[];
  // 模块数据更新，删除后立马更新，新增后 需要等新增这条数据编辑完整后 才会更新，页面就不需要考虑不完整的脏数据了
  onChange?: (payload: IDPSReportUpdatesOfTheWeekVO[]) => void;
}

const { injectable } = Table.addons;

const UpdatesOfWeek: React.FC<IUpdatesOfWeekProps> = (props) => {
  const { style, className, title = CARD_TITLE, onTitleChange, isLoading, filter, projects, value, onChange } = props;

  const addons: TableAddon<IDPSReportUpdatesOfTheWeekVO>[] = [
    injectable({
      row: (props, context) => {
        const { className } = props || {};
        const { record } = context || {};
        const { data_type: dataType } = record || {};
        return {
          ...props,
          className: classnames(className, {
            'dbg-table-tr-highlight': dataType === DataType.AutoFetched,
          }),
        };
      },
    }),
  ];

  const { records, setRecords, onAdd, onDelete } = useDPSReportModule<IDPSReportUpdatesOfTheWeekVO>({
    buildRecord,
    value,
    onChange,
  });

  const columns: TableColumn<IDPSReportUpdatesOfTheWeekVO>[] = getColumnsEditable({
    projects: projects || [],
    onProjectChange: async (cvm: IDPSReportUpdatesOfTheWeekVO, payload: string) => {
      try {
        const { mock_id: mockId } = cvm || {};
        const recordIdx = records?.findIndex((record) => record?.mock_id === mockId);
        if (recordIdx !== -1) {
          const project = projects?.find((item) => {
            const { project_id: projectId } = item || {};
            return projectId === payload;
          });
          const changes = await getUpdatesOfWeekChanges({ ...filter, project_id: payload });
          const changesValue = setNewFileUrlChangesContent(changes);
          const recordTmp = {
            ...records?.[recordIdx],
            ...omit(project, 'business_owner', 'pteam'),
            data_type: DataType.ManualAdded,
            changes: changesValue || buildDefaultChanges(),
          };
          const recordsTmp = [...records?.slice(0, recordIdx), recordTmp, ...records?.slice(recordIdx + 1)];
          setRecords(recordsTmp);
          onChange?.(recordsTmp);
        }
      } catch (exception) {}
    },
    onChangesChange: (cvm: IDPSReportUpdatesOfTheWeekVO, payload: IDPSReportUpdatesOfTheWeekChangeVO[]) => {
      const { mock_id: mockId } = cvm || {};
      const recordIdx = records?.findIndex((record) => record?.mock_id === mockId);
      if (recordIdx !== -1) {
        const recordTmp = {
          ...records?.[recordIdx],
          changes: payload,
        };
        const recordsTmp = [...records?.slice(0, recordIdx), recordTmp, ...records?.slice(recordIdx + 1)];
        setRecords(recordsTmp);
        onChange?.(recordsTmp);
      }
    },
  });

  return (
    <ReportTable
      style={style}
      className={classnames(
        'dbg-table-vertical-align-top dbg-dps-report__hightlights-table-card dbg-dps-report-updates-table',
        className,
      )}
      isSupportRenameTitle
      // title={title}
      title={title || CARD_TITLE}
      onTitleChange={onTitleChange}
      isLoading={isLoading}
      addons={addons}
      columns={columns}
      records={records}
      recordKey={getRecordKeyOfMockable}
      onAdd={onAdd}
      onDelete={onDelete}
    />
  );
};

export default UpdatesOfWeek;
